import React from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import { translate } from 'react-i18next'

import { CATEGORIES } from './../../constants'

import { Form, SelectInput } from '../UI'
import { NotificationManager } from 'react-notifications'

import Loader from '../UI/Loader'

import { validateRequired } from './../../libs/validation'

import UPDATE_GUIDE_PROFILE_CATEGORIES_QUERY from './../../graphql/UpdateGuideProfileCategories.graphql'
import USER_PROFILE_BY_USER_QUERY from './../../graphql/UserByID.graphql'

import get from 'lodash/get'

class CategoryForm extends React.Component {
  state = {
    routeIndex: 5,
    saving: false,
    items: [
      {
        id: _.uniqueId(),
        category: null
      }
    ],
    error: ''
  }

  componentWillMount() {
    const categories = _.get(this, 'props.data.User.guideProfile.categories', [])
    if (categories && categories.length) {
      const items = categories.map(category => {
        return {
          id: _.uniqueId(),
          category
        }
      })
      this.setState({ items })
    }
  }

  componentWillReceiveProps(nextProps) {
    const categories = _.get(this, 'props.data.User.guideProfile.categories', [])
    const categoriesNext = _.get(nextProps, 'data.User.guideProfile.categories', [])
    if (categories && categoriesNext && categories.length !== categoriesNext.length) {
      const items = categoriesNext.map(category => {
        return {
          id: _.uniqueId(),
          category
        }
      })
      this.setState({ items })
    }
  }

  getLanguageOptions = () => {
    const { t } = this.props
    const options = []
    for (let category in CATEGORIES) {
      if (CATEGORIES.hasOwnProperty(category)) {
        options.push({
          label: t('categories:' + category),
          value: category
        })
      }
    }
    return options
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true,
      error: ''
    })
    const categories = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 9) === 'category_') {
        if (categories.indexOf(values[item]) !== -1) {
          this.setState({
            saving: false,
            error: 'Each category must be chosen once'
          })
          return
        }
        categories.push(values[item])
      }
    }
    this.props
      .updateGuideProfile({
        variables: {
          id: this.props.data.User.guideProfile.id,
          categories
        }
      })
      .then(() => {
        this.setState(
          () => ({
            saving: false
          }),
          () => {
            this.props.history.push('/activity-guide-profile/finish')
          }
        )
      })
      .catch(err => {
        this.setState(() => ({
          saving: false
        }))

        NotificationManager.error(err.message, 'Error', 5000)
      })
  }

  handleAddClick = () => {
    this.setState(state => ({
      items: [
        ...state.items,
        {
          id: _.uniqueId(),
          category: null
        }
      ]
    }))
  }

  handleRemoveClick = id => {
    this.setState(state => ({
      items: state.items.filter(item => item.id !== id)
    }))
  }

  render() {
    const { t } = this.props
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { saving } = this.state
    return (
      <div className="steps-screen__form">
        <div className="steps-screen__form-title">{t('category')}</div>
        <div className="steps-screen__form-subtitle" />
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
              {this.state.items.map(el => {
                return (
                  <div key={el.id} className="removable-item-row">
                    <SelectInput
                      options={this.getLanguageOptions()}
                      id={`category_${el.id}`}
                      placeholder={t('select_category')}
                      initialValue={el.category}
                      validationFuncs={[validateRequired]}
                      simpleValue
                      clearable={false}
                    />
                    {this.state.items.length > 1 && (
                      <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                        <span className="icon-cancel" /> {t('remove')}
                      </div>
                    )}
                  </div>
                )
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_category')}
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export default compose(
  translate('guide'),
  graphql(USER_PROFILE_BY_USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  graphql(UPDATE_GUIDE_PROFILE_CATEGORIES_QUERY, {
    name: 'updateGuideProfile'
  }),
  withRouter
)(CategoryForm)



// WEBPACK FOOTER //
// src/components/Guide/CategoryForm.jsx